// ==========================================================
// PWAInstallPrompt — "Ana ekrana ekle" banner'ı
// ==========================================================

import { useState, useEffect } from 'react';
import { Download, X } from 'lucide-react';

interface BeforeInstallPromptEvent extends Event {
  prompt(): Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

export default function PWAInstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState<BeforeInstallPromptEvent | null>(null);
  const [dismissed, setDismissed] = useState(() => localStorage.getItem('pwa_install_dismissed') === '1');

  useEffect(() => {
    const handler = (e: Event) => {
      e.preventDefault();
      setDeferredPrompt(e as BeforeInstallPromptEvent);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  if (!deferredPrompt || dismissed) return null;

  const install = async () => {
    if (!deferredPrompt) return;
    await deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') setDeferredPrompt(null);
  };

  const dismiss = () => {
    localStorage.setItem('pwa_install_dismissed', '1');
    setDismissed(true);
  };

  return (
    <div className="fixed bottom-20 left-4 right-4 md:left-auto md:right-6 md:w-80 z-[200] animate-in slide-in-from-bottom-4">
      <div className="flex items-center gap-3 p-3.5 rounded-2xl bg-[rgba(10,11,16,0.96)] border border-emerald-500/25 backdrop-blur-xl shadow-xl">
        <div className="p-2 rounded-xl bg-emerald-500/10 flex-shrink-0">
          <span className="text-xl">🍄</span>
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-xs font-bold text-white">Ana Ekrana Ekle</p>
          <p className="text-[10px] text-gray-400">Çevrimdışı çalışır, bildirimleri destekler</p>
        </div>
        <button
          onClick={install}
          className="flex items-center gap-1 px-3 py-1.5 rounded-lg bg-emerald-500/15 border border-emerald-500/25 text-emerald-400 text-[10px] font-bold hover:bg-emerald-500/25 cursor-pointer transition-all flex-shrink-0"
        >
          <Download className="w-3 h-3" />
          Yükle
        </button>
        <button onClick={dismiss} className="text-gray-600 hover:text-gray-400 cursor-pointer flex-shrink-0">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
